import styled from "styled-components"

export const FullSessionScheduleBoardContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  max-height: 100%;
  max-width: 100%;
  gap: 3px;
  padding-right: 6px;
  cursor: pointer;
`

export const FullSessionScheduleImage = styled.img`
  width: auto;
  height: auto;
  cursor: pointer;
  max-height: min(1200px, calc(100vh - 56px - 220px));
  object-fit: contain;
  display: block;
  @media screen and (orientation: landscape) and (max-height: 571px) {
    width: 100%;
    max-height: unset;
  }

  @media screen and (orientation: portrait) {
    height: 100%;
    max-width: unset;
  }

  @media only screen and (min-aspect-ratio: 13/10) {
    max-height: unset;
    width: 100%;
  }
`
